<template>
<v-app v-if="!isMobile">
    <NavigationBar v-model="drawer" />
     <v-main><router-view></router-view></v-main>
</v-app>
<v-app v-else>
    <NagivationBarMobile />
     <v-main><router-view></router-view></v-main>
</v-app>
</template>



<script>
import NavigationBar from "../src/components/NagivationBar.vue"
import NagivationBarMobile from "../src/components/NavigationBarMobile.vue"

export default {
  name: "App",
  components: {NavigationBar, NagivationBarMobile},
  data() {
      return {
      drawer: true,
      isMobile: true,
      };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  }

</script>